import { useCallback, useState } from 'react';

export const useProcessingLine = () => {
  const [processingLine, setProcessingLine] = useState<string | undefined>(
    undefined,
  );

  const isBeingProcessed = useCallback(
    (id: string) => processingLine === id,
    [processingLine],
  );

  const setProcessing = useCallback((id?: string) => setProcessingLine(id), []);

  const processLine = async (
    id: string,
    callback: (id: string) => Promise<unknown>,
  ) => {
    setProcessing(id);
    await callback(id);
    setProcessing();
  };

  return {
    processingLine,
    setProcessing,
    isBeingProcessed,
    processLine,
  };
};
